// extracted by mini-css-extract-plugin
module.exports = {"icon":"data-view_icon_k6ZSU","textShadow":"data-view_textShadow_3jsuq","item":"data-view_item_Q39Sp","name":"data-view_name_1hWah","dataWrap":"data-view_dataWrap_2ez4D"};